import img1 from './10001.jpg'
import img2 from './10002.jpg'
import img3 from './10003.jpg'
import img4 from './10004.jpg'
import img5 from './10005.jpg'
export const imgs = [img1, img2, img3, img4, img5]